import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import reducers from '../reducers';
import middlewares from '../middlewares';



export default (initialState) =>
  createStore(reducers, initialState, applyMiddleware(thunk, ...middlewares));
